import React from 'react';
import { BlankLink } from '@contently/toolkit';

const StoryAlreadyClaimed = () => (
  <div>
    <h2>We’re sorry, but this story has been claimed by another contributor.</h2>
    <div>
      <BlankLink href="https://contently.net">Subscribe to The Freelancer</BlankLink>
    </div>
    <div>
      <BlankLink href="https://help.contently.com/en/articles/2821759-how-do-i-reach-out-to-my-managing-editor">
        Contact your Managing Editor
      </BlankLink>
    </div>
    <div>
      <BlankLink href="https://help.contently.com/en/articles/1589932-how-to-optimize-your-portfolio">
        Optimize your portfolio
      </BlankLink>
    </div>
    <div>
      <BlankLink href="https://help.contently.com">Visit our Help Center</BlankLink>
    </div>
  </div>
);

export default StoryAlreadyClaimed;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_already_claimed/story_already_claimed.jsx